export const NEW_SCHEDULE_EVENT = "newScheduleEventForm";
export const DELETE_SCHEDULE_EVENT = "deleteScheduleEventForm";
export const EDIT_SCHEDULE_EVENT = "editScheduleEventForm";